import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Item = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 25px 15px;
`;

export const Text = styled(Typography.Body)<{ $isRed?: boolean }>`
  margin-left: 10px;
  color: ${({ theme, $isRed }) =>
    $isRed ? theme.palette.system.red : theme.palette.primary.labels};
`;

export const Form = styled.form`
  display: grid;
  gap: 30px;
  padding-bottom: 20px;
`;

export const RenameModalBody = styled.div`
  display: grid;
  gap: 20px;
  padding: 20px;
`;

export const RenameModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const RenameModalTitle = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  margin: 0;
`;

export const RenameModalCloseButton = styled.button`
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
